import {apiGet, apiPost} from './index'

/**
 * 题目曝光
 * POST
 * URL /course/section/question/browse
 */
export const questionBrowse = (params) => apiPost('/api/course/section/question/browse', params)

/**
 * 小节题目答题
 * POST
 * /class/question/user/popup
 */
export const questionUserPopup = (params) => apiPost('/api/class/question/user/popup', params)

/**
 * /courses/isScorm/{courseId}
 * GET
 */
export const isScorm = (courseId) => apiGet(`/api/courses/isScorm/${courseId}`)



// WEBPACK FOOTER //
// ./src/api/scorm.js